module.exports = __webpack_public_path__ + "static/media/worship.dd648980.jpg";